import { LocalizedText } from "../../requests/personalization/types";

export const EMPTY_LOCALIZED_TEXT: LocalizedText = { cz: "", en: "" };
export const PERSONALITION_FALLBACK_BOOLEAN = false;
export const DEFAULT_TEMPLATES_ON_MODULES = 3;
